"use strict";

/**
 * Allows for running a sequence of css transitions with callback.
 */
export default class AnimSequencer {

  static TRANSITION_END = "transitionend webkittransitionend otransitionend";
  static ANIMATIION_END = "animationend webkitanimationend oanimationend";

  #$elements = [];
  #changeFunctions = [];  // TODO: Don't use parallel arrays.
  #callback = null;
  #isRunning = false;

  constructor() { }

  /*
   * Adds an item to the sequence.
   *
   * @param $element is the element whose css `transitionend` event will be listened for.
   * @param changeFunction is code to be executed that will trigger the element's css transition.
   * 
   * Be aware that if the changeFunction fails to trigger a css animation on the element, the 
   * on-complete callback will never get called.
   */
  addAnim($element, changeFunction) {
    this.#$elements.push($element);
    this.#changeFunctions.push(changeFunction);
  }

  /*
   * Sets the function that will be called at the end of the animation sequence.
   */
  setCallback(callback) { 
    this.#callback = callback; 
  }

  get isRunning() { return this.#isRunning; }

  run() {
    this.#isRunning = true;
    this.#doNext();
  }

  #doNext() {
    if (this.#$elements.length === 0) {
      this.#isRunning = false;
      if (this.#callback) {
        const callback = this.#callback;
        this.#callback = null;
        callback();
      }
      return;
    }

    const $element = this.#$elements.shift();
    $element.on(AnimSequencer.TRANSITION_END, $.proxy((e) => {  // TODO: use fat arrow correctly
      $element.off(AnimSequencer.TRANSITION_END);
      //cl('done', $element[0]);
      // Wait for next tick to prevent false triggers.
      setTimeout($.proxy(this.#onComplete, this), 0);
    }, this));

    const changeFunction = this.#changeFunctions.shift();
    changeFunction();
  }

  #onComplete() {
    this.#doNext();
  }

  /**
   * Triggers a callback at the end of a css transition (by using an AnimSequence with only one step).
   */
  static runOne($element, changeFunction, callback) {
    const seq = new AnimSequencer();
    seq.addAnim($element, changeFunction);
    seq.setCallback(callback);
    seq.run();
    return seq;
  }

  /**
   * Triggers a callback at the end of a css animation (as opposed to a transition).
   * TODO: Consider parameterizing transition-vs-animation or maybe just listening for _both_ types of events period.
   */
  static listenForAnimationEnd($element, changeFunction, callback) {
    $element.on(AnimSequencer.ANIMATIION_END, $.proxy((e) => {
      // cl('animation ended', $element[0]);
      $element.off(AnimSequencer.ANIMATIION_END);
      // Wait for next tick to prevent false triggers.
      setTimeout($.proxy(callback, this), 0);
    }, this));
    changeFunction();
  }
}
